<template>
  <div v-if="items.length" class="row mb-4">
    <div class="col-lg-12">
      <div class="card-account account-refund-requests" :style="accountStyle">
        <h4 class="mb-4">Reembolso</h4>

        <ul class="list-unstyled mb-0">
          <li v-for="item in items" :key="item.product_id" class="refund-item">
            <div
              class="d-flex flex-wrap align-items-center justify-content-between"
            >
              <div class="refund-item-info pr-3">
                <div class="product-name">{{ item.product_name }}</div>
                <div class="status-text">{{ statusText(item) }}</div>
                <div v-if="decisionText(item)" class="decision-text">
                  {{ decisionText(item) }}
                </div>
              </div>
              <button
                v-if="item.eligible"
                class="btn btn-light px-4"
                :style="buttonStyle"
                @click="openModal(item)"
              >
                Solicitar reembolso
              </button>
            </div>
          </li>
        </ul>

        <refund-request-modal
          v-model="modalVisible"
          :item="selectedItem"
          @created="onCreated"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import RefundRequestModal from "@/components/account/RefundRequestModal";

export default {
  name: "RefundRequests",
  components: { RefundRequestModal },
  data() {
    return {
      modalVisible: false,
      selectedItem: null
    };
  },
  computed: {
    ...mapGetters("refundRequests", { items: "availableItems" }),
    accountStyle() {
      return this.$setup.theme === "dark"
        ? { background: "#151823" }
        : { background: "#FFF" };
    },
    buttonStyle() {
      return this.$setup.theme === "dark"
        ? { background: "#FFF" }
        : { background: "#3e56ac", color: "#FFF" };
    },
    userEmail() {
      return (this.$user.user && this.$user.user.email) || "";
    }
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      return this.$store.dispatch("refundRequests/list").catch(() => {});
    },
    formatDay(value) {
      if (!value) {
        return "";
      }
      const parts = String(value)
        .split("T")[0]
        .split("-");
      if (parts.length < 3) {
        return String(value);
      }
      return `${parts[2]}/${parts[1]}`;
    },
    requestDay(item) {
      return this.formatDay(item.request && item.request.created_at);
    },
    statusText(item) {
      switch (item.reason_code) {
        case "pending": {
          const day = this.requestDay(item);
          return day
            ? `Solicitação enviada em ${day} — aguardando o produtor.`
            : "Solicitação enviada — aguardando o produtor.";
        }
        case "out_of_warranty": {
          const day = this.formatDay(item.warranty_at);
          return day
            ? `Prazo de garantia encerrado em ${day}.`
            : "Prazo de garantia encerrado.";
        }
        case "already_refunded":
          return "Este pedido já foi estornado.";
        case "processing":
          return "Estorno em processamento — aguarde a confirmação do banco.";
        case "no_order":
          return this.userEmail
            ? `Não encontramos uma compra deste curso no e-mail ${this.userEmail}. Fale com o suporte.`
            : "Não encontramos uma compra deste curso. Fale com o suporte.";
        default: {
          if (!item.eligible) {
            return "Reembolso indisponível para este curso.";
          }
          const day = this.formatDay(item.warranty_at);
          return day
            ? `Dentro da garantia até ${day}.`
            : "Dentro do prazo de garantia.";
        }
      }
    },
    decisionText(item) {
      const request = item.request;
      if (!request) {
        return "";
      }
      if (request.status === "approved") {
        return "Solicitação aprovada — o estorno foi autorizado pelo produtor.";
      }
      if (request.status === "rejected") {
        return request.rejection_reason
          ? `Solicitação recusada: ${request.rejection_reason}`
          : "Solicitação recusada pelo produtor.";
      }
      return "";
    },
    openModal(item) {
      this.selectedItem = item;
      this.modalVisible = true;
    },
    onCreated() {
      this.$message.success(
        "Solicitação enviada. O produtor vai analisar e você será avisado por e-mail."
      );
      this.load();
    }
  }
};
</script>

<style lang="scss" scoped>
.account-refund-requests {
  .refund-item {
    padding: 12px 0;
    border-bottom: 1px solid rgba(105, 106, 126, 0.2);

    &:last-child {
      border-bottom: none;
      padding-bottom: 0;
    }
  }

  .refund-item-info {
    .product-name {
      font-size: 14px;
      font-weight: 500;
    }

    .status-text {
      font-size: 13px;
      opacity: 0.75;
      margin-top: 2px;
    }

    .decision-text {
      font-size: 13px;
      opacity: 0.75;
      margin-top: 2px;
    }
  }

  button {
    margin-top: 8px;
  }
}
</style>
